
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auction-rules",
      function () {
        return require("private-next-pages/auction-rules.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auction-rules"])
      });
    }
  